"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = interopDefault;

// https://github.com/moment/moment/issues/3650
// since we are using ts 3.5.1, it should be safe to remove.
function interopDefault(m) {
  return m["default"] || m;
}
//# sourceMappingURL=interopDefault.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/_util/interopDefault.js
// module id = 100
// module chunks = 0